import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PublicRouter from './public/routes';
import AdminRouter from './private/admin/routes';
import UserRouter from './private/user/routes';
import RefereeRouter from './private/referee/routes';
import { withCookies } from 'react-cookie';

const MainRouter = (props) => {
  return (
    <main>
      <Switch>
        {/* <Redirect strict from={url + '/'} to={url} /> */}
        <Route path='/register' render={() => !props.user ? <PublicRouter/> : <UserRouter/>} />
        <Route
          path='/my'
          render={ () => (
            !props.user ? null : (props.groups.includes('ADMIN') ? <Redirect to='/admin' /> : <UserRouter/> )
          )}
        />
        <Route
          path='/admin'
          render={() => {
            return props.groups.includes('ADMIN') && <AdminRouter/>;
          }}
        />
        <Route
          path='/referee'
          render={() => {
            return props.groups.includes('REFEREE') && <RefereeRouter/>;
          }}
        />
        <Route component={PublicRouter} />
      </Switch>
    </main>
  );
};

export default withCookies(MainRouter);



// WEBPACK FOOTER //
// ./src/Navigator.js